import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import { Paper, Typography } from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo-new-login.svg";
import ResetProfilePasswordComponent from "../../components/auth/ResetProfilePassword";

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
   width: 197px;
  height: 43px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function ResetProfilePassword() {
  return (
    <React.Fragment>
      <Brand />
      <Wrapper>
        <Helmet title="Create Password" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Reset Password
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Reset password for your account
        </Typography>

        <ResetProfilePasswordComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default ResetProfilePassword;
